import { useLocalStorage } from './useLocalStorage';

/**
 * Custom hook for managing user-created decks
 * Stores custom decks separately from default decks in localStorage
 */
export const useCustomDecks = () => {
  const [customDecks, setCustomDecks] = useLocalStorage('customDecks', {});

  const addDeck = (deckName) => {
    if (!deckName || customDecks[deckName]) {
      return false;
    }
    setCustomDecks({
      ...customDecks,
      [deckName]: []
    });
    return true;
  };

  const deleteDeck = (deckName) => {
    const newDecks = { ...customDecks };
    delete newDecks[deckName];
    setCustomDecks(newDecks);
  };

  const renameDeck = (oldName, newName) => {
    if (!newName || newName === oldName || customDecks[newName]) {
      return false;
    }
    const newDecks = { ...customDecks };
    newDecks[newName] = newDecks[oldName];
    delete newDecks[oldName];
    setCustomDecks(newDecks);
    return true;
  };

  const addCard = (deckName, card) => {
    if (!customDecks[deckName]) {
      return false;
    }
    setCustomDecks({
      ...customDecks,
      [deckName]: [...customDecks[deckName], card]
    });
    return true;
  };

  const updateCard = (deckName, cardIndex, updatedCard) => {
    if (!customDecks[deckName] || cardIndex >= customDecks[deckName].length) {
      return false;
    }
    const newCards = [...customDecks[deckName]];
    newCards[cardIndex] = updatedCard;
    setCustomDecks({
      ...customDecks,
      [deckName]: newCards
    });
    return true;
  };

  const deleteCard = (deckName, cardIndex) => {
    if (!customDecks[deckName] || cardIndex >= customDecks[deckName].length) {
      return false;
    }
    const newCards = customDecks[deckName].filter((_, i) => i !== cardIndex);
    setCustomDecks({
      ...customDecks,
      [deckName]: newCards
    });
    return true;
  };

  const importDeck = (deckName, cards) => {
    if (!deckName || !Array.isArray(cards)) {
      return false;
    }
    setCustomDecks({
      ...customDecks,
      [deckName]: cards
    });
    return true;
  };

  const restoreAllDecks = (decks) => {
    setCustomDecks(decks);
  };

  return {
    customDecks,
    addDeck,
    deleteDeck,
    renameDeck,
    addCard,
    updateCard,
    deleteCard,
    importDeck,
    restoreAllDecks
  };
};
